// extracted by mini-css-extract-plugin
export default {"tooltip":"jp-z","sharingV2":"kp-z","sharingIconsV2":"lp-z","links":"mp-z","link":"np-z","facebookV2":"op-z","twitterV2":"pp-z","pinterestV2":"qp-z"};